import type { TransportOptionDto } from '@api/machines'
import { MolsonAutocomplete, MolsonTextField } from '@components/reusable'
import { molsonUseTheme } from '@theme/customMuiExports'

type TransportAutocompleteProps = {
  options: TransportOptionDto[]
  selectedOption: TransportOptionDto | string
  onChange: (optionId: number | null) => void
  placeholder: string
  sectionError?: boolean
  isArchived?: boolean
  displayPriceDifference?: number
}

export const TransportAutocomplete = ({
  options,
  selectedOption,
  onChange,
  placeholder,
  sectionError,
  isArchived,
  displayPriceDifference
}: TransportAutocompleteProps) => {
  const theme = molsonUseTheme()
  return (
    <MolsonAutocomplete
      getOptionLabel={option =>
        typeof option === 'string' ? option : (option.name ?? '')
      }
      options={options}
      renderInput={params => (
        <MolsonTextField
          placeholder={placeholder}
          value={
            typeof selectedOption === 'string'
              ? selectedOption
              : selectedOption?.name
          }
          {...params}
          error={sectionError || isArchived}
        />
      )}
      onChange={(_, value) =>
        onChange((value as TransportOptionDto)?.id ?? null)
      }
      sx={{
        ...(isArchived && {
          '.MuiAutocomplete-input': {
            color: theme.palette.primary.error,
            textDecoration: 'line-through !important'
          },
          '.MuiFormControl-root': { textDecoration: 'line-through !important' },
          color: theme.palette.primary.error
        }),
        width: displayPriceDifference !== undefined ? '100%' : '50%'
      }}
      value={selectedOption}
    />
  )
}
